class Config {
    constructor() {
        this.domain = window.location.protocol + '//' + window.location.hostname;
    }

    getDomain() {
        return this.domain;
    }

    getImageDomain() {
        const imageDomain = process.env.IMAGE_HOST?.replace(/^"|"$/g, '');
        return imageDomain || window.env?.baseUrl || this.getDomain();
    }
}

export default Config;
